import { RequirementParams, RequirementSubjectType } from "@/backend/access/requirement/types";

export type RequirementTab = 'details' | 'verification' | 'evidence' | 'review';

export const DEFAULT_REQUIREMENT_TAB: RequirementTab = 'details';

// The page used to have six tabs. Links to the old ones land on the tab that took over their content.
const OLD_TABS: Record<string, RequirementTab> = {
  requirement: 'details',
  alignment: 'details',
  planning: 'details',
  design: 'evidence',
};

/** The tab a `?tab=` value opens, including the names of tabs the page no longer has. */
export function resolveRequirementTab(rawTab: string | null): RequirementTab {
  if (rawTab === 'verification' || rawTab === 'evidence' || rawTab === 'review') {
    return rawTab;
  }
  return (rawTab && OLD_TABS[rawTab]) || DEFAULT_REQUIREMENT_TAB;
}

type RequirementLocation = Pick<RequirementParams, 'id' | 'subjectId' | 'subjectType'>;

/**
 * The page for a requirement. A project's requirement lives under its project;
 * a FuSa organization's requirement has no project and stays at /requirements/:id.
 */
export function requirementPath(requirement: RequirementLocation, tab: RequirementTab = DEFAULT_REQUIREMENT_TAB): string {
  const base = requirement.subjectType === RequirementSubjectType.PROJECT
    ? `/projects/${requirement.subjectId}/requirements/${requirement.id}`
    : `/requirements/${requirement.id}`;
  return `${base}?tab=${tab}`;
}

/** Where to go once a requirement is deleted: the list it was shown in. */
export function requirementListPath(requirement: Pick<RequirementParams, 'subjectId' | 'subjectType'>): string {
  return requirement.subjectType === RequirementSubjectType.PROJECT
    ? `/projects/${requirement.subjectId}/requirements`
    : `/fusa-organizations/${requirement.subjectId}`;
}
